document.querySelectorAll('.tabs button').forEach((button) => button.addEventListener('click', () => {
  const image = document.querySelector('#stitch-image');
  const caption = document.querySelector('#stitch-caption');
  if (image) {
    const base = image.src.replace(/[^/]+(?:\?.*)?$/, '');
    image.src = base + button.dataset.image;
  }
  if (caption && button.dataset.caption) caption.textContent = button.dataset.caption;
}));

document.querySelectorAll('[data-home-filter]').forEach((button) => button.addEventListener('click', () => {
  const filter = button.dataset.homeFilter;
  document.querySelectorAll('[data-home-filter]').forEach((item) => item.classList.toggle('active', item === button));
  document.querySelectorAll('[data-home-category]').forEach((card) => {
    card.hidden = filter !== 'all' && card.dataset.homeCategory !== filter;
  });
}));

const drawer = document.querySelector('.sk-cart-drawer');
const scrim = document.querySelector('.sk-cart-scrim');
const toast = document.querySelector('.sk-toast');
const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);

function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('show');
  window.setTimeout(() => toast.classList.remove('show'), 2200);
}

function openDrawer() {
  if (!drawer || !scrim) return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  scrim.hidden = false;
}

function closeDrawer() {
  if (!drawer || !scrim) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  scrim.hidden = true;
}

async function renderCart(open = false) {
  if (!drawer) return;
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  const cart = await response.json();
  const items = drawer.querySelector('[data-cart-items]');
  const total = drawer.querySelector('[data-cart-total]');
  if (total) total.textContent = money(cart.total_price);
  document.querySelectorAll('.sk-cart').forEach((link) => { link.textContent = link.textContent.replace(/\(\d+\)/, `(${cart.item_count})`); });
  if (items) {
    items.innerHTML = cart.items.length ? cart.items.map((item, index) => `<article class="sk-drawer-item"><img src="${item.image || ''}" alt=""><div><h3>${item.product_title}</h3><p>${item.variant_title || ''}</p><p>${item.quantity} × ${money(item.final_price)}</p></div><button class="sk-drawer-remove" type="button" data-cart-remove="${index + 1}" aria-label="Entfernen">×</button></article>`).join('') : '<p>Noch ist es ruhig hier.</p>';
  }
  if (open) openDrawer();
}

document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
document.querySelectorAll('.sk-cart').forEach((link) => link.addEventListener('click', (event) => { event.preventDefault(); renderCart(true); }));
document.addEventListener('click', async (event) => {
  const remove = event.target.closest('[data-cart-remove]');
  if (!remove) return;
  await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(remove.dataset.cartRemove), quantity: 0 }) });
  renderCart(true);
});

document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => form.addEventListener('submit', async (event) => {
  event.preventDefault();
  const submit = form.querySelector('[type="submit"]');
  if (submit) submit.disabled = true;
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('add failed');
    showToast('Zum Warenkorb hinzugefügt.');
    await renderCart(true);
  } catch (error) {
    form.submit();
  } finally {
    if (submit) submit.disabled = false;
  }
}));
